import LoopSlider from "./LoopSlider";
import Swiper from "swiper";
import { Pagination, Autoplay, Navigation, Thumbs } from "swiper/modules";

let homeBannerSlider = new Swiper(".home-banner-slider .swiper", {
	modules: [Pagination, Autoplay, Navigation],
	slidesPerView: 1,
	spaceBetween: 12,
	loop: true,
	autoplay: {
		delay: 4000,
	},
	pagination: {
		el: ".home-banner-slider .swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".home-banner-slider .swiper-btn-next",
		prevEl: ".home-banner-slider .swiper-btn-prev",
	},
});

let regulationSlider = new Swiper(".regulation-slider .swiper", {
	slidesPerView: 2.5,
	spaceBetween: 12,
	modules: [Navigation],
	breakpoints: {
		768: {
			slidesPerView: 3.5,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 40,
		},
	},
	navigation: {
		nextEl: ".regulation-slider .swiper-btn-next",
		prevEl: ".regulation-slider .swiper-btn-prev",
	},
});

let majorAdvantageSlider = new Swiper(".major-advantage-slider .swiper", {
	slidesPerView: 1.5,
	spaceBetween: 12,
	modules: [Navigation],
	breakpoints: {
		576: {
			slidesPerView: 2.5,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3.5,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 40,
		},
	},
	navigation: {
		nextEl: ".major-advantage-slider .swiper-btn-next",
		prevEl: ".major-advantage-slider .swiper-btn-prev",
	},
});

const partnerSlider = new Swiper(".partner-slider .swiper", {
	modules: [Autoplay],
	slidesPerView: 3.5,
	loop: true,
	speed: 4000,
	autoplay: {
		delay: 0,
		disableOnInteraction: false,
	},
	breakpoints: {
		576: {
			slidesPerView: 4.5,
		},
		768: {
			slidesPerView: 6.5,
		},
		1024: {
			slidesPerView: 8,
		},
	},
});

const newsSlider = new LoopSlider(".news-slider", {
	576: {
		spaceBetween: 16,
		slidesPerView: 2.5,
	},
	768: {
		spaceBetween: 16,
		slidesPerView: 3.5,
	},
	1024: {
		spaceBetween: 40,
		slidesPerView: 3,
	},
});

const singleSlider = new LoopSlider(".single-slider", {
	576: {
		spaceBetween: 20,
		slidesPerView: 1,
	},
	768: {
		spaceBetween: 20,
		slidesPerView: 1,
	},
	1024: {
		spaceBetween: 40,
		slidesPerView: 1,
	},
});

const doubleSlider = new LoopSlider(".double-slider", {
	576: {
		spaceBetween: 20,
		slidesPerView: 1.5,
	},
	768: {
		spaceBetween: 20,
		slidesPerView: 2.5,
	},
	1024: {
		spaceBetween: 40,
		slidesPerView: 2,
	},
});

$(document).ready(function () {
	const bioTimelineYearSlider = new Swiper(
		".bio-timeline-year-slider .swiper",
		{
			modules: [Navigation],
			slidesPerView: 4.5,
			spaceBetween: 12,
			slideToClickedSlide: true,
			breakpoints: {
				768: {
					slidesPerView: 6.5,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 8,
					spaceBetween: 40,
				},
			},
		}
	);

	const bioTimelineContentSlider = new Swiper(
		".bio-timeline-content-slider .swiper",
		{
			modules: [Thumbs, Navigation],
			slidesPerView: 1,
			spaceBetween: 12,
			thumbs: {
				swiper: bioTimelineYearSlider,
			},
			navigation: {
				nextEl: ".bio-timeline-year-slider .swiper-btn-next",
				prevEl: ".bio-timeline-year-slider .swiper-btn-prev",
			},
		}
	);
});
